import {Injectable} from '@angular/core';


@Injectable()
export class ToastService {
    constructor() {
    }


}


